<template>
    <div>
        <van-swipe  class="my-swipe" :loop="false" :initial-swipe="initialSwipe" width="100%" height="100vh" touchable>
            <van-swipe-item>
                <div class="page page1">
                    <p class="content">{{details.grangeName}}</p>
                    <div class="infomate">
                        <p v-if="details.contactName">
                            {{details.contactName}}/{{details.contactMobile}}</p>
                        <p>{{details.address}}</p>
                    </div>
                    <span class="left-slide">左滑查看 <label>>></label></span>
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="page farm-scenery">
                    <h6 class="title">农庄风光</h6>
                    <ul class="infomate">
                        <li>农庄上传了
                            <b>{{details.provideServices && details.provideServices.length || 0}}
                            </b>张照片</li>
                        <li>美丽农庄定格一瞬</li>
                        <div class="imgs">
                            <span v-if="details.photos && details.photos.length > 0">
                                <img v-for="img in details.photos"
                                     :key="img.imageUrl"
                                     :src="img.imageUrl"
                                     class="img-item" alt="">
                            </span>
                            <img v-else src="@/assets/image/farmShare/zwt.png" class="img-item" alt="">
                        </div>
                    </ul>
<!--                    <span class="left-slide">左滑查看 <label>>></label></span>-->
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="page page2">
                    <h6 class="title">农庄服务</h6>
                    <ul class="infomate">
                        <li>我们不止是种植</li>
                        <li>还提供
                            <b>{{details.provideServices && details.provideServices.length || 0}}
                            </b>种附加服务</li>
                        <li v-if="details.provideServices && details.provideServices.length > 0">
                            <span class="bold-font" v-for="item in details.provideServices" :key="item.serviceIcon">
                                <img :src="item.serviceIcon" class="service-icon">
                                {{item.serviceName}}
                            </span>
                        </li>
                        <li>边吃边玩，共度好时光</li>
                    </ul>
                </div>
            </van-swipe-item>
            <van-swipe-item v-if="details.certifications>0">
                <div class="page page3">
                    <h6 class="title">农庄认证</h6>
                    <ul class="infomate">
                        <li>农庄提供 <b>{{details.certificationsTotal || 0}}
                            </b> 张认证证书，其中</li>
                            <li v-for="item in details.certifications" :key="item.typeMsg">
                                <img class="icon" :src="item.images[0]" v-if="item.images && item.images.length > 0"/>
                                {{item.typeMsg}} <b>{{item.images && item.images.length}}</b> 张</li>
                            <li>国家标准，能量化的放心</li>
                    </ul>
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="page page4">
                    <h6 class="title">农庄品质</h6>
                    <ul class="infomate">
                        <li>我们种植的 <b>{{dataList.length}}</b> 种作物</li>
                        <li>每种都可以查询种植追溯记录</li>
                        <li>品质看得见 吃的每一口都安心</li>
                    </ul>
                    <ul class="card">
                        <li v-for="(item,index) in dataList" :key="item.cropName+index" @click="toFarmDetail(item)">
                            <img :src="item.images[0]">
                            <h6>
                                <span class="card-title">{{item.cropName}}·{{item.breedName}}</span>
                                <label class="card-subtitle">
                                    {{item.plantingDate && moment(item.plantingDate).format('MM月DD日')}}
                                    - {{item.stageName}}</label>
                            </h6>
                            <span class="record">{{item.plantingNoteNum}}条记录</span>
                        </li>
                        <span class="load-more" @click="toListsPage">点我查看更多 ~</span>
                    </ul>


                </div>
            </van-swipe-item>
            <template #indicator>
                <div class="custom-indicator"></div>
            </template>
        </van-swipe>
    </div>
</template>

<script>
    import Vue from 'vue';
    import moment from "moment"
    import { Swipe, SwipeItem } from 'vant';

    Vue.use(Swipe);
    Vue.use(SwipeItem);
    export default {
        data(){
            return{
                moment,
                details:'',
                loading: false,
                finished: false,
                refreshing: false,
                dataList:[],
                sendData:{
                    current:1,
                    size:3,
                    grangeId:''
                },
                total:0,
                initialSwipe:0,
            }
        },
        created() {
            this.sendData.grangeId = this.$route.query && this.$route.query.id
            this.getGrange()
            if( this.$route.query && this.$route.query.changeSwipe){
                this.initialSwipe = this.details &&
                                    this.details.certifications &&
                                    this.details.certifications>0 ? 3:2
            }
            //创建组件时，加载第1页数据
            this.getPlantingPage();
        },
        methods:{
            /*
            *  获取详情
            * */
            getGrange(){
                let {sendData} = this
                this.$api.getGrange({id:sendData.grangeId}).then(res => {
                    this.details = res.data
                    if(this.details.photos.length > 6){
                        this.details.photos = this.details.photos.slice(0,5)
                    }

                    if(this.details.certifications){
                        let total = 0
                        this.details.certifications.forEach((value)=>{
                            total += value.images.length
                        })
                        this.details.certificationsTotal = total
                    }

                })
            },

            /*
            * 获取列表
            * */
            getPlantingPage(){
                let {sendData} = this
                this.$api.getPlantingPage(sendData).then(res => {
                    this.total = res.data.total
                    this.dataList = res.data.records;  //请求返回当页的列表
                })
            },

            toFarmDetail(value){
                let p ={
                    farmlandId: value.id,
                    cropName: value.cropName,
                    breedName: value.breedName,
                    images:value.images[0],
                }
                this.$router.push({name:'farmDetail' , query:{data:JSON.stringify(p)}})
            },

            toListsPage(){
                this.$router.push({name:'farmLists' ,query:{grangeId: this.sendData.grangeId}})
            },

        }
    }
</script>

<style scoped lang="scss">
    @import './css/index';
</style>